<div class="edit-block" [class.disabled]="disabled">
  @if (icon) {
  <mat-icon class="material-icons">{{ icon }}</mat-icon>
  } @if (label) {
  {{ label | translate }}:&nbsp; }
  <div
    #editable
    [attr.title]="value"
    class="edit-name"
    [attr.contenteditable]="disabled ? false : true"
    (blur)="saveField($event)"
  >
    {{ value }}
  </div>
  @if (!disabled) {
  <mat-icon (click)="editable.focus()" class="edit-action">edit</mat-icon>
  }
</div>
